import invoiceTitlePage from './view/invoiceTitle.html'

export default function invoiceTitle() {
    return {
        restrict: 'E',
        scope: {
            taxCode: '<', // 税号
            machineCode: '<', // 盘号
            invoice: '=', // 对应发票
        },
        replace: true,
        template: invoiceTitlePage,
        link(scope) {
            const getInvoiceCodeAndNum = (data) => {
                if (data != null) {
                    if (data.retcode !== -1) {
                        const SIDParam = $.parseJSON(data.value)
                        scope.invoiceNumber = SIDParam.InfoNumber
                        scope.invoiceCode = SIDParam.InfoTypeCode
                    }
                } else {
                    logger.logError('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
                }
            }
            function init() {
                if (!scope.invoice) {
                    return
                }
                if (!scope.invoice.invoiceCode) {
                    window.top.TaxCore.tax.invInfo(
                        Number(scope.invoice.invType),
                        getInvoiceCodeAndNum,
                        scope.taxCode,
                        scope.machineNo, 0,
                    )
                } else {
                    scope.invoiceNumber = scope.invoice.invoiceNumber
                    scope.invoiceCode = scope.invoice.invoiceCode
                }
                const now = new Date()
                const nowStr = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
                // 已开发票取开票时间 待开详情取创建时间 新增待开取当前时间
                scope.createTime = scope.invoice.invoiceDate || scope.invoice.createTime || nowStr
            }
            scope.$watch('invoice.invType', () => {
                init()
            })
            scope.showCheckCode = function showCheckCode() {
                const { invoice } = scope
                if (!invoice) return
                const { invType } = invoice
                return invType === '2' || invType === '51' || invType === '41'
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/invoiceRelated/invoiceTitle.js